<template>
  <v-row justify="center">
    <v-dialog
        v-model="show"
        fullscreen
        persistent
        style="height: 100vh"
    >
      <v-card style="background-color: #f5f5f5; border-radius: 0">

        <!-- presupuesto -->
        <div>
          <ValidationObserver ref="validationObserver">
            <v-form ref="form" lazy-validation  class="pa-1">
              <v-row>
                <v-col lg="6" md="12">
                  <v-row class="pa-2 pb-0 align-center">
                    <v-col cols="1" style="text-align: center">
                      <v-btn
                          icon
                          class="primary"
                          dark
                          @click="show = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col lg="11" md="9">
                      <v-card elevation="2">

                        <!--Tarjeta con la información del cliente seleccionado-->
                        <MiniCliente :cliente="cliente" />
                      </v-card>
                    </v-col>

                    <v-col cols="2" style="text-align: center"
                           v-if="presupuesto.cliente && !($vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'xl')">
                      <v-btn
                          class="primary parpadeaSuave"
                          dark
                          @click="dialog_lineas = true"
                      >
                        {{ $t('Añadir línea') }}
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-divider class="ml-8 mr-8 mt-2 mb-2"/>

                  <!--Lineas de la presupuesto-->
                  <div class="contLineasPresupuesto">
                    <div
                        v-for="(current_linea, index) in presupuesto.lineas_presupuesto"
                        :key="index"
                        class="overflow-y-auto"
                    >
                      <LineaFormPresupuesto
                          :current_linea="current_linea"
                          :index="index"
                          :can_aplicar_descuento="can_aplicar_descuento"
                          :tipos_descuentos="data_form.tipos_descuentos"
                          @toggle_collapse="toggle_collapse"
                          @delete_linea_presupuesto="delete_linea"
                          :presupuesto="presupuesto"
                      />
                    </div>
                    <div ref="scrollBottom"></div>
                  </div>

                  <!--Footer de la presupuesto (descuento directo a la presupuesto y observaciones)-->
                  <v-card elevation="6" class="ma-2 footerPresupuesto primary">
                    <v-card-text>
                      <v-row class="mt-2">
                        <v-col cols="3">
                          <v-text-field
                              v-model="presupuesto.valor_descuento"
                              :readonly="!can_aplicar_descuento"
                              class="white"
                              type="number"
                              hide-details
                              outlined
                              dense
                          >
                            <template v-slot:label>
                              <span class='labelFooterPresupuesto'>{{ $t('Descuento') }}</span>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="5">
                          <v-select
                              class="white"
                              v-model="presupuesto.tipo_descuento"
                              hide-details
                              :readonly="!can_aplicar_descuento"
                              :items="data_form.tipos_descuentos"
                              :no-data-text="$t('No hay datos')"
                              dense
                              outlined
                          >
                            <template v-slot:label>
                              <span class='labelFooterPresupuesto'>{{ $t('Tipo descuento') }}</span>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                              class="white"
                              v-model="presupuesto.base_imponible"
                              type="number"
                              hide-details
                              outlined
                              dense
                              readonly
                          >
                            <template v-slot:label>
                              <span class='labelFooterPresupuesto'>{{ $t('Base imponible') }}</span>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col cols="12">
                          <v-text-field
                              class="white"
                              v-model="presupuesto.observaciones"
                              hide-details
                              outlined
                              dense
                          >
                            <template v-slot:label>
                              <span class='labelFooterPresupuesto'>{{ $t('Observaciones') }}</span>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <!--Botones pago-->
                      <v-row class="mt-0">
                        <v-col cols="3" style="text-align: center" offset="1">
                          <span class="v-btn white--text mt-1">{{ $t("Total") }}: {{ total | money }}</span>
                        </v-col>

                        <v-col cols="3">
                          <v-btn
                              text
                              dark
                              @click="save"
                              :disabled="presupuesto.venta"
                              :class="presupuesto.venta?'':'white primary--text'"
                          >
                            <v-icon left>mdi-cash</v-icon>
                            {{ $t('Guardar') }}
                          </v-btn>
                        </v-col>
                        <v-col cols="3">
                          <v-menu offset-x>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                  text
                                  dark
                                  v-on="on"
                                  :disabled="presupuesto.venta"
                                  :class="presupuesto.venta?'':'white primary--text'"
                              >
                                {{ $t('Guardar y imprimir') }}
                                <v-icon right>mdi-chevron-right</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                  @click="save_print"
                              >
                                <v-list-item-icon>
                                  <v-icon>mdi-printer</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('Guardar y imprimir PDF') }}</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                  @click="save_print_ticket"
                              >
                                <v-list-item-icon>
                                  <v-icon>mdi-printer-pos</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('Guardar y imprimir ticket') }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-col>

                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Tablas de items a añadir -->
                <v-col v-if="$vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'xl'" lg="6" class="pr-6 pl-2 mt-2">
                  <!-- TabBar -->
                  <v-tabs class="elevation-2" v-model="active_tab" grow>
                    <v-tab href="#tab-servicio">
                      <span class="tab_title">{{ $t("Servicios") }}</span>
                    </v-tab>
                    <!-- Contenido del tab -->
                    <v-tab-item value="tab-servicio" class="pa-4 grey lighten-5">
                      <TablaServicios
                          :selected_filters="{ is_active: true }"
                          :show_buscador="active_tab === 'tab-servicio'"
                          :is_presupuesto="true"
                          @on_click_selected="add_linea_presupuesto"
                          :is_venta="true"
                      />
                    </v-tab-item>
                    <v-tab href="#tab-producto">
                      <span class="tab_title">{{ $t("Productos") }}</span>
                    </v-tab>
                    <!-- Contenido del tab -->
                    <v-tab-item value="tab-producto" class="pa-4 grey lighten-5">
                      <TablaProductos
                          :selected_filters="{ is_active: true }"
                          :show_buscador="active_tab === 'tab-producto'"
                          :is_presupuesto="true"
                          @on_click_selected="add_linea_presupuesto"
                          :is_venta="true"
                      />
                    </v-tab-item>
                    <v-tab href="#tab-bono">
                      <span class="tab_title">{{ $t("Bonos") }}</span>
                    </v-tab>
                    <!-- Contenido del tab -->
                    <v-tab-item value="tab-bono" class="pa-4 grey lighten-5">
                      <TablaBonos
                          :selected_filters="{ is_active: true }"
                          :show_buscador="active_tab === 'tab-bono'"
                          :is_presupuesto="true"
                          @on_click_selected="add_linea_presupuesto"
                          :is_venta="true"
                      />
                    </v-tab-item>
                    <v-tab href="#tab-pack">
                      <span class="tab_title">{{ $t("Packs") }}</span>
                    </v-tab>
                    <!-- Contenido del tab -->
                    <v-tab-item value="tab-pack" class="pa-4 grey lighten-5">
                      <TablaPacks
                          :selected_filters="{ is_active: true }"
                          :show_buscador="active_tab === 'tab-pack'"
                          :is_presupuesto="true"
                          @on_click_selected="add_linea_presupuesto"
                          :is_venta="true"
                      />
                    </v-tab-item>
                    <v-tab href="#tab-tarjeta_regalo">
                      <span class="tab_title">{{ $t("Tarjetas Regalo") }}</span>
                    </v-tab>
                    <!-- Contenido del tab -->
                    <v-tab-item value="tab-tarjeta_regalo" class="pa-4 grey lighten-5">
                      <TablaTarjetasRegalo
                          :selected_filters="{ is_active: true, is_vendida: false }"
                          :show_buscador="active_tab === 'tab-tarjeta_regalo'"
                          :is_presupuesto="true"
                          @on_click_selected="add_linea_presupuesto"
                          :is_venta="true"
                      />
                    </v-tab-item>
                    <v-tab href="#tab-tarjeta_fidelidad">
                      <span class="tab_title">{{ $t("Tarjetas Fidelidad") }}</span>
                    </v-tab>
                    <!-- Contenido del tab -->
                    <v-tab-item value="tab-tarjeta_fidelidad" class="pa-4 grey lighten-5">
                      <TablaTarjetasFidelidad
                          :selected_filters="{ is_active: true, is_vendida: false }"
                          :show_buscador="active_tab === 'tab-tarjeta_fidelidad'"
                          :is_presupuesto="true"
                          @on_click_selected="add_linea_presupuesto"
                          :is_venta="true"
                      />
                    </v-tab-item>
                    <v-tab href="#tab-suscripcion">
                      <span class="tab_title">{{ $t("Suscripciones") }}</span>
                    </v-tab>
                    <!-- Contenido del tab -->
                    <v-tab-item value="tab-suscripcion" class="pa-4 grey lighten-5">
                      <TablaSuscripciones
                          :selected_filters="{ is_active: true, is_vendida: false }"
                          :show_buscador="active_tab === 'tab-suscripcion'"
                          :is_presupuesto="true"
                          @on_click_selected="add_linea_presupuesto"
                          :is_venta="true"
                      />
                    </v-tab-item>
                  </v-tabs>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </div>

      </v-card>
    </v-dialog>

    <!-- Para mostrar la tabla para añadir lineas de presupuesto en tablets-->
    <Dialog :title="$t('Añadir línea')" v-if="!($vuetify.breakpoint.name === 'lg' || $vuetify.breakpoint.name === 'xl')"
            v-show="dialog_lineas" v-model="dialog_lineas" width="1000" max_width="1000">
      <template v-slot:content>
        <!-- TabBar -->
        <v-tabs class="elevation-2" v-model="active_tab" grow>
          <v-tab href="#tab-servicio">
            <span class="tab_title">{{ $t("Servicios") }}</span>
          </v-tab>
          <!-- Contenido del tab -->
          <v-tab-item value="tab-servicio" class="pa-4 grey lighten-5">
            <TablaServicios
                :selected_filters="{ is_active: true }"
                :show_buscador="active_tab === 'tab-servicio'"
                :is_presupuesto="true"
                @on_click_selected="add_linea_presupuesto"
                :is_venta="true"
            />
          </v-tab-item>
          <v-tab href="#tab-producto">
            <span class="tab_title">{{ $t("Productos") }}</span>
          </v-tab>
          <!-- Contenido del tab -->
          <v-tab-item value="tab-producto" class="pa-4 grey lighten-5">
            <TablaProductos
                :selected_filters="{ is_active: true }"
                :show_buscador="active_tab === 'tab-producto'"
                :is_presupuesto="true"
                @on_click_selected="add_linea_presupuesto"
                :is_venta="true"
            />
          </v-tab-item>
          <v-tab href="#tab-bono">
            <span class="tab_title">{{ $t("Bonos") }}</span>
          </v-tab>
          <!-- Contenido del tab -->
          <v-tab-item value="tab-bono" class="pa-4 grey lighten-5">
            <TablaBonos
                :selected_filters="{ is_active: true }"
                :show_buscador="active_tab === 'tab-bono'"
                :is_presupuesto="true"
                @on_click_selected="add_linea_presupuesto"
                :is_venta="true"
            />
          </v-tab-item>
          <v-tab href="#tab-pack">
            <span class="tab_title">{{ $t("Packs") }}</span>
          </v-tab>
          <!-- Contenido del tab -->
          <v-tab-item value="tab-pack" class="pa-4 grey lighten-5">
            <TablaPacks
                :selected_filters="{ is_active: true }"
                :show_buscador="active_tab === 'tab-pack'"
                :is_presupuesto="true"
                @on_click_selected="add_linea_presupuesto"
                :is_venta="true"
            />
          </v-tab-item>
          <v-tab href="#tab-tarjeta_regalo">
            <span class="tab_title">{{ $t("Tarjetas Regalo") }}</span>
          </v-tab>
          <!-- Contenido del tab -->
          <v-tab-item value="tab-tarjeta_regalo" class="pa-4 grey lighten-5">
            <TablaTarjetasRegalo
                :selected_filters="{ is_active: true, is_vendida: false }"
                :show_buscador="active_tab === 'tab-tarjeta_regalo'"
                :is_presupuesto="true"
                @on_click_selected="add_linea_presupuesto"
                :is_venta="true"
            />
          </v-tab-item>
          <v-tab href="#tab-tarjeta_fidelidad">
            <span class="tab_title">{{ $t("Tarjetas Fidelidad") }}</span>
          </v-tab>
          <!-- Contenido del tab -->
          <v-tab-item value="tab-tarjeta_fidelidad" class="pa-4 grey lighten-5">
            <TablaTarjetasFidelidad
                :selected_filters="{ is_active: true, is_vendida: false }"
                :show_buscador="active_tab === 'tab-tarjeta_fidelidad'"
                :is_presupuesto="true"
                @on_click_selected="add_linea_presupuesto"
                :is_venta="true"
            />
          </v-tab-item>
          <v-tab href="#tab-suscripcion">
            <span class="tab_title">{{ $t("Suscripciones") }}</span>
          </v-tab>
          <!-- Contenido del tab -->
          <v-tab-item value="tab-suscripcion" class="pa-4 grey lighten-5">
            <TablaSuscripciones
                :selected_filters="{ is_active: true, is_vendida: false }"
                :show_buscador="active_tab === 'tab-suscripcion'"
                :is_presupuesto="true"
                @on_click_selected="add_linea_presupuesto"
                :is_venta="true"
            />
          </v-tab-item>
        </v-tabs>
      </template>
    </Dialog>

  </v-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: "FormPresupuesto",

  data: () => ({
    presupuesto: {},
    aws_s3_bucket_url: process.env.VUE_APP_AWS_S3_BUCKET,
    data_form: {},
    configuracion_venta: {},
    active_tab: "tab-servicio",
    dialog_lineas: false,
    set_tarjetas_regalo: new Set()
  }),

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    user: {
      get () {
        return this.$store.getters['auth/user']
      }
    },

    total(){
      if(!this.presupuesto.lineas_presupuesto){
        this.presupuesto.lineas_presupuesto = []
      }
      let total = 0
      this.presupuesto.lineas_presupuesto.forEach((current_linea) => {
        total += (current_linea.cantidad * current_linea.precio)
        if(current_linea.tipo_descuento === 'm'){
          total -= current_linea.valor_descuento
        }else{
          total -= (current_linea.cantidad * current_linea.precio) * current_linea.valor_descuento / 100
        }
      })
      if(this.presupuesto.tipo_descuento === 'm'){
        total -= this.presupuesto.valor_descuento
        this.presupuesto.importe_descuento_moneda = this.presupuesto.valor_descuento
        this.presupuesto.importe_descuento_porcentaje = 0
      }else{
        this.presupuesto.importe_descuento_porcentaje = total * this.presupuesto.valor_descuento / 100
        total -= total * this.presupuesto.valor_descuento / 100
        this.presupuesto.importe_descuento_moneda = 0
      }

      if(this.presupuesto.importe_programa_puntos){
        total -= this.presupuesto.importe_programa_puntos
      }

      if(this.presupuesto.tarjeta_fidelidad_vendida_obj){

        let importe_a_usar_tarjeta_fidelidad = this.presupuesto.tarjeta_fidelidad_vendida_obj.importe_restante
        if(total <= this.presupuesto.tarjeta_fidelidad_vendida_obj.importe_restante){
          importe_a_usar_tarjeta_fidelidad = total
        }
        this.presupuesto.importe_tarjeta_fidelidad = importe_a_usar_tarjeta_fidelidad
        total -= importe_a_usar_tarjeta_fidelidad
      }

      if(this.presupuesto.importe_tarjeta_regalo){
        if(this.presupuesto.importe_tarjeta_regalo > this.presupuesto.total){
          this.presupuesto.importe_tarjeta_regalo = this.presupuesto.total
        }
        total -= this.presupuesto.importe_tarjeta_regalo
      }

      this.presupuesto.total = total

      return total.toFixed(2)
    },

    can_modificar_precio(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("modificar_precios_en_venta")) {
          return true
        }
      }
      return false
    },
  },

  async mounted() {
    await this.get_data_form()
    await this.get_configuracion_venta()

    this.initialize_presupuesto()
    this.presupuesto = {... this.presupuesto, ... this.item}

    //deep copy
    if(this.item.lineas_presupuesto){
      this.presupuesto.lineas_presupuesto = []
      for(let index = 0; index<this.item.lineas_presupuesto.length;index++){
        this.presupuesto.lineas_presupuesto.push({...this.item.lineas_presupuesto[index], collapsed: false})
      }
    }

    this.presupuesto.fecha = `${this.$moment(this.presupuesto.fecha).format('YYYY-MM-DD')}`
    this.presupuesto.cliente = this.cliente

    this.presupuesto.lineas_presupuesto.forEach((current_linea) => {
      current_linea.collapsed = true
    })
  },

  props: ['value', 'item', 'cliente', 'titulo'],

  components: {
    ValidationProvider,
    ValidationObserver,
    MiniCliente: () => import('@/views/Clientes/Components/MiniCliente'),
    TablaServicios: () => import('@/views/Configuracion/Servicios/Servicios/components/TablaServicios'),
    TablaProductos: () => import('@/views/Configuracion/Productos/Productos/components/TablaProductos'),
    TablaBonos: () => import('@/views/Configuracion/Bonos/components/TablaBonos'),
    TablaPacks: () => import('@/views/Configuracion/Packs/components/TablaPacks'),
    TablaTarjetasRegalo: () => import('@/views/Marketing/TarjetasRegalo/components/TablaTarjetasRegalo'),
    TablaTarjetasFidelidad: () => import('@/views/Marketing/TarjetasFidelidad/components/TablaTarjetasFidelidad'),
    TablaSuscripciones: () => import('@/views/Configuracion/Suscripciones/components/TablaSuscripciones'),
    LineaFormPresupuesto: () => import('@/views/Clientes/Components/LineaFormPresupuesto'),
  },

  watch: {
    'presupuesto': {
      deep: true,
      handler() {
        this.get_base_imponible()
        this.set_totales_lineas_presupuesto()
        this.set_totales_lineas_presupuesto()
      }
    }
  },

  methods: {
    /**
     * Recuperar los datos necesarios para pintar el formulario
     * @returns {Promise<void>}
     */
    async get_data_form() {
      try {
        this.data_form = await this.$store.dispatch('venta/get_form')
      } catch (err) {
        this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    initialize_presupuesto() {
      this.presupuesto = {}
      this.presupuesto.created_by = null
      this.presupuesto.fecha = this.$moment().format('YYYY-MM-DD')
      this.presupuesto.valor_descuento = 0
      this.presupuesto.tipo_descuento = 'p'
      this.presupuesto.total = 0
      this.presupuesto.base_imponible = 0
      this.presupuesto.lineas_presupuesto = []
      // Si es un nuevo presupuesto sin empleado, le asignamos el empleado logado
      if (!this.presupuesto.created_by && this.user.is_employee) {
        this.presupuesto.created_by = this.user.id
      }
      this.presupuesto = {...this.presupuesto}
    },

    async get_configuracion_venta() {
      this.configuracion_venta = await this.$store.dispatch('configuraciones/get', 'venta');
    },

    can_aplicar_descuento() {
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("aplicar_descuentos_en_venta")) {
          return true
        }
      }
      return false
    },

    toggle_collapse(linea_venta) {
      linea_venta.collapsed = !linea_venta.collapsed
      // Esta línea es para que detecte los cambios
      this.presupuesto = {...this.presupuesto}
    },

    add_linea_presupuesto(item) {

      let tipo_item = this.active_tab.replace('tab-', '')
      if (this.cliente.is_anonymous && (tipo_item === 'bono' || tipo_item === 'tarjeta_fidelidad')) {
        return
      }

      if (tipo_item === 'tarjeta_regalo' && this.set_tarjetas_regalo.has(item.id)) {
        return this.$snotify.error(
            this.$t('Una tarjeta de regalo solo se puede vender una vez.'),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }

      // Vemos cual es el impuesto
      let impuesto = this.configuracion_venta.impuesto_servicios;
      if (tipo_item === 'producto') {
        impuesto = this.configuracion_venta.impuesto_productos;
      }

      if (item.impuesto) {
        impuesto = item.impuesto
      }

      const linea_presupuesto = {
        collapsed: true,
        descripcion: item.nombre,
        assigned_to: this.presupuesto.assigned_to,
        cantidad: 1,
        valor_descuento: 0,
        tipo_descuento: 'p',
        impuesto,
        precio: item.precio,
        total: 0
      }
      linea_presupuesto[tipo_item] = item.id
      this.presupuesto.lineas_presupuesto.push(linea_presupuesto)

      if (tipo_item === 'tarjeta_regalo') {
        this.set_tarjetas_regalo.add(item.id)
      }

      // Esta línea es para que detecte los cambios
      this.presupuesto = {...this.presupuesto}
      this.$refs.scrollBottom.scrollIntoView()
    },

    /**
     * Elimina una línea de presupuesto
     * @param index
     */
    delete_linea(index) {
      if (this.presupuesto.lineas_presupuesto[index].tarjeta_regalo) {
        this.set_tarjetas_regalo.delete(this.presupuesto.lineas_presupuesto[index].tarjeta_regalo)
      }

      this.presupuesto.lineas_presupuesto.splice(index, 1);
    },

    /**
     * Devuelve el valor de un impuesto a partir del value del desplegable
     * @param value
     * @returns {number}
     */
    get_valor_impuesto(value) {
      let valor_impuesto = 0;
      this.data_form.impuestos.forEach((current_object_impuesto) => {
        if (current_object_impuesto.value === value) {
          valor_impuesto = current_object_impuesto.text
        }
      })
      return valor_impuesto
    },

    /**
     * Calcula la base imponible del presupuesto
     */
    get_base_imponible() {
      if (!this.presupuesto.lineas_presupuesto) {
        this.presupuesto.base_imponible = 0
      }

      let base_imponible = 0
      this.presupuesto.lineas_presupuesto.forEach((current_linea) => {
        let iva = this.get_valor_impuesto(current_linea.impuesto)
        if (iva < 10) {
          iva = "0" + iva;
          iva = iva.replace(",", "");
          iva = iva.replace(".", "");
        }
        iva = parseFloat("1." + iva);
        base_imponible = this.presupuesto.total / iva
      })
      this.presupuesto.base_imponible = base_imponible.toFixed(2)
    },

    set_totales_lineas_presupuesto() {
      this.presupuesto.lineas_presupuesto.forEach((current_linea) => {
        let total = current_linea.cantidad * current_linea.precio

        if (this.presupuesto.tarjeta_fidelidad_vendida_obj) {
          const tarjeta = this.presupuesto.tarjeta_fidelidad_vendida_obj
          if (current_linea.servicio) {
            current_linea.valor_descuento = tarjeta.descuento_servicios
            current_linea.importe_descuento_porcentaje = tarjeta.descuento_servicios
            current_linea.importe_descuento_moneda = 0
            current_linea.tipo_descuento = 'p'
          } else if (current_linea.producto) {
            current_linea.valor_descuento = tarjeta.descuento_productos
            current_linea.importe_descuento_porcentaje = tarjeta.descuento_servicios
            current_linea.importe_descuento_moneda = 0
            current_linea.tipo_descuento = 'p'
          }
        }

        if (current_linea.valor_descuento) {
          if (current_linea.tipo_descuento === 'm') {
            total -= current_linea.valor_descuento
            current_linea.importe_descuento_moneda = current_linea.valor_descuento
            current_linea.importe_descuento_porcentaje = 0
          } else {
            current_linea.importe_descuento_porcentaje = (total * current_linea.valor_descuento / 100)
            current_linea.importe_descuento_moneda = 0
            total -= (total * current_linea.valor_descuento / 100)
          }
        }
        current_linea.total = total
      })
    },

    /**
     * Guarda el presupuesto
     * @returns {Promise<void>}
     */

    async save() {

      const form_valid = await this.$refs.validationObserver.validate()

      if (form_valid && !this.presupuesto.venta) {
        try {
          const presupuesto_to_save = {...this.presupuesto}
          presupuesto_to_save.fecha = `${this.$moment(presupuesto_to_save.fecha).format('YYYY-MM-DDThh:mm:ss')}`
          presupuesto_to_save.cliente = this.presupuesto.cliente.id

          const presupuesto = await this.$store.dispatch("presupuestos/save", presupuesto_to_save);

          this.$snotify.success(
              this.$t("Acción realizada con éxito"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          this.$emit('on_save', presupuesto)
        } catch (err) {
          this.$snotify.error(
              this.$t("Ha ocurrido un error"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }
    },

    async save_print() {

      const form_valid = await this.$refs.validationObserver.validate()

      if (form_valid && !this.presupuesto.venta) {
        try {
          const presupuesto_to_save = {...this.presupuesto}
          presupuesto_to_save.fecha = `${this.$moment(presupuesto_to_save.fecha).format('YYYY-MM-DDThh:mm:ss')}`
          presupuesto_to_save.cliente = this.presupuesto.cliente.id

          const presupuesto = await this.$store.dispatch("presupuestos/save", presupuesto_to_save);

          this.$snotify.success(
              this.$t("Acción realizada con éxito"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          this.$emit('on_save_print', presupuesto)
        } catch (err) {
          this.$snotify.error(
              this.$t("Ha ocurrido un error"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }
    },

    async save_print_ticket() {

      const form_valid = await this.$refs.validationObserver.validate()

      if (form_valid && !this.presupuesto.venta) {
        try {
          const presupuesto_to_save = {...this.presupuesto}
          presupuesto_to_save.fecha = `${this.$moment(presupuesto_to_save.fecha).format('YYYY-MM-DDThh:mm:ss')}`
          presupuesto_to_save.cliente = this.presupuesto.cliente.id

          const presupuesto = await this.$store.dispatch("presupuestos/save", presupuesto_to_save);

          this.$snotify.success(
              this.$t("Acción realizada con éxito"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          this.$emit('on_save_print_ticket', presupuesto)
        } catch (err) {
          this.$snotify.error(
              this.$t("Ha ocurrido un error"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }
    },
  }
}
</script>

<style scoped>
header{
  border-radius: 0 !important;
}

.contLineasPresupuesto {
  max-height: calc(85vh - 165px);
  overflow-y: auto;
}

.footerPresupuesto {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 49vw;
  height: 165px;
}
@media screen and (max-width: 1263px) {
  .footerPresupuesto{
    width: 98vw;
  }
}

.big {
  font-size: 2em
}

.v-card__text, .v-card__actions {
  padding: 0 8px;
}
.labelFooterPresupuesto{
  background-color: white;
  color: black;
  border-radius: 4px;
  padding-left: 6px;
  padding-right: 6px
}
</style>
